import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {signoutToEvent, toggleDialogUnsubscribe, toggleDialogUnsubscribeSuccess} from '../../actions';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_event_details';
import ReactHtmlParser from 'react-html-parser';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DoneIcon from '@material-ui/icons/Done';
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';

class EventDetailsUnsubscribe extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.signupOrOut !== this.props.signupOrOut) {
            if (this.props.signupOrOut) {
                if (!this.props.currentUserSubscribed && this.props.dialogUnsubscribeOpen) {
                    // The user has just been unsubscribed.
                    // Hide the unsubscribe dialog, and show the confirmation dialog.
                    this.props.toggleDialogUnsubscribeSuccess();
                }
            }
        }
    }

    handleSignout = (e) => {
        e.preventDefault();

        const {event} = this.props;
        console.log('test')
        this.props.signoutToEvent(event);
    };

    handleCloseDialog = () => {
        this.props.toggleDialogUnsubscribe();
    };

    handleCloseSuccessDialog = () => {
        this.props.toggleDialogUnsubscribeSuccess();
    };

    render() {
        const {event, signupOrOutLoading, dialogUnsubscribeOpen, dialogUnsubscribeSuccessOpen} = this.props;

        let title = event.title;
        if (event.title_html !== '' && event.title_html !== null) {
            title = event.title_html;
        }

        return (
            <Fragment>
                <Dialog
                    open={dialogUnsubscribeOpen}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="dialog-checkin-unsubscribe-title"
                    className="dialog-event-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-title">
                            <span className="title"><Translate id="event_details.disenroll_from" /></span>
                            <span className="subtitle">{ReactHtmlParser(title)}</span>
                        </div>
                        <div className="buttons">
                            {signupOrOutLoading ? (
                                <LoadingSpinner align="center" />
                            ) : (
                                <Fragment>
                                    <Button onClick={this.handleSignout} className="btn btn-confirm" variant="contained" color="primary" size="large" autoFocus>
                                        <DoneIcon className="icon" />
                                        <Translate id="event_details.button_confirmer" />
                                    </Button>
                                    <br />
                                    <Button onClick={this.handleCloseDialog} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                        <Translate id="event_details.button_annuler" />
                                    </Button>
                                </Fragment>
                            )}
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={dialogUnsubscribeSuccessOpen}
                    onClose={this.handleCloseSuccessDialog}
                    aria-labelledby="dialog-checkin-unsubscribe-confirm-title"
                    className="dialog-event-checkin"
                >
                    <DialogContent className="dialog-checkin-content">
                        <div id="dialog-checkin-unsubscribe-confirm-title">
                            <span className="title"><Translate id="event_details.title_thanks" /></span>
                            <span className="subtitle"><Translate id="event_details.notice_disenroll_confirmed" /></span>
                        </div>
                        <div className="buttons">
                            <Button onClick={this.handleCloseSuccessDialog} className="btn btn-cancel" variant="outlined" color="secondary" size="large">
                                <Translate id="event_details.button_close" />
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </Fragment>
        );
    }
}

EventDetailsUnsubscribe.propTypes = {
    event: PropTypes.object.isRequired,
    currentUserSubscribed: PropTypes.bool.isRequired,
    signoutToEvent: PropTypes.func.isRequired,
    toggleDialogUnsubscribe: PropTypes.func.isRequired,
    toggleDialogUnsubscribeSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    signupOrOut: state.events.eventSignupOrOut,
    signupOrOutLoading: state.events.eventSignupOrOutLoading,
    signupOrOutError: state.events.eventSignupOrOutError,
    dialogUnsubscribeOpen: state.events.dialogUnsubscribeOpen,
    dialogUnsubscribeSuccessOpen: state.events.dialogUnsubscribeSuccessOpen,
    currentUserSubscribed: state.events.currentUserSubscribed,
});

export default connect(mapStateToProps, {signoutToEvent, toggleDialogUnsubscribe, toggleDialogUnsubscribeSuccess})(withLocalize(EventDetailsUnsubscribe));


// WEBPACK FOOTER //
// ./src/features/Events/components/Details/EventDetailsUnsubscribe.js